// Portions of this code are adapted from the MUI Toolpad PageHeaderToolbar component.
// Source: https://github.com/mui/toolpad/tree/master/packages/toolpad-core/src/PageContainer
// MUI is licensed under the MIT License: https://github.com/mui/toolpad/blob/master/LICENSE
import * as React from 'react';

import { styled } from '@mui/material';

const PageHeaderToolbarRoot = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  flex: 1,
  justifyContent: 'flex-end',
  alignItems: 'center',
  gap: theme.spacing(2),
}));

export interface PageHeaderToolbarProps {
  children?: React.ReactNode;
}

/**
 *
 * Demos:
 *
 * - [Page Container](https://mui.com/toolpad/core/react-page-container/)
 *
 * API:
 *
 * - [PageHeaderToolbar API](https://mui.com/toolpad/core/api/page-header-toolbar)
 */
export function PageHeaderToolbar(props: PageHeaderToolbarProps) {
  return <PageHeaderToolbarRoot {...props} />;
}
